import React from 'react';


function A8AdMyVision() {
    return (
        <div>
            <p>PR: トップ戦略ファーム出身者が提供する、転職支援サービスを受けませんか?（無料の転職相談）</p>
            <a href="https://px.a8.net/svt/ejp?a8mat=3YYLXS+3PYLFM+5B0Y+5ZU29" rel="nofollow">
                {/* @ts-ignore */}
                <img border="0" width="300" height="250" alt="" src="https://www25.a8.net/svt/bgt?aid=240120208225&wid=003&eno=01&mid=s00000024757001007000&mc=1" />
            </a>
            {/* @ts-ignore */}
            <img border="0" width="1" height="1" src="https://www13.a8.net/0.gif?a8mat=3YYLXS+3PYLFM+5B0Y+5ZU29" alt="" />
        </div>
    );
}

export default A8AdMyVision;
